import Vue from 'vue'
import Vuex from 'vuex'
import { collegeList, collegeCategoryList, provinceList } from "../api/common";
import { memberCategoryList } from "@/api/member";
import { adminList, adminRoleList } from "@/api/admin";
import { clientList,agreementList } from "@/api/operation";
import { readcategorylist } from "@/api/read";
import { examcategorylist } from "@/api/exam";
import { mediatopiclist, mediaaccountlist, mediawritinglist } from "@/api/select";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    collegeList: [],
    userCategorys: [],
    adminList: [],
    clientList: [],
    readCategorys: [],
    collegeCategoryList: [],
    provinceList: [],
    examcategorylist: [],
    roleList: [],
    mediatopiclist: [],
    accountlist: [],
    writinglist: [],
    agreementList:[]
  },
  mutations: {

  },
  actions: {
    // 协议列表
    fetchAgreementList({ state }) {
      let query = {
        isPaging:0
      }
      agreementList(this.query).then(res => {
        state.agreementList =  res.list || []
        // console.log('state.agreementList:', state.agreementList)
      })
    },
    getAllColleges({ state }) {
      //获取院校列表
      let query = {
        isPaging: 0,
      };
      collegeList(query).then((res) => {
        state.collegeList = res.list || [];
      });
    },
    // 用户分类
    getUserCategorys({ state }) {
      memberCategoryList({ status: 1, isPaging: 0 }).then((res) => {
        state.userCategorys = res.list || [];
      });
    },
    // 管理员列表
    getAdminList({ state }, query = {}) {
      adminList({ status: 1, isPaging: 0, ...query }).then((res) => {
        state.adminList = res.list || [];
      });
    },
    // 角色列表
    getRoleList({ state }) {
      adminRoleList({ status: 1, isPaging: 0 }).then((res) => {
        state.roleList = res.list || [];
      });
    },
    // 客户端列表
    getClientList({ state }) {
      clientList({ isPaging: 0 }).then((res) => {
        state.clientList = res.list || [];
      });
    },
    // 资料分类
    getReadCategorys({ state }) {
      readcategorylist({ status: 1, isPaging: 0 }).then((res) => {
        state.readCategorys = res.list || [];
      });
    },
    // 院校分类
    getCollegeCategorys({ state }) {
      collegeCategoryList({ status: 1, isPaging: 0 }).then((res) => {
        state.collegeCategoryList = res.list || [];
      });
    },
    // 省份列表
    getProvinceList({ state }) {
      provinceList({ status: 1, isPaging: 0 }).then((res) => {
        state.provinceList = res.list || [];
      });
    },
    // 考试题目分类(查询列表)
    getExamCategoryList({ state }) {
      examcategorylist({ isPaging: 0 }).then((res) => {
        state.examcategorylist = res.list || [];
      });
    },
    // 选题(查询列表)
    getMediaTopicList({ state }) {
      mediatopiclist({ isPaging: 0 }).then((res) => {
        state.mediatopiclist = res.list || [];
      });
    },
    // 新媒体账号(查询列表)
    getMediaAccountList({ state }) {
      mediaaccountlist({ isPaging: 0 }).then((res) => {
        state.accountlist = res.list || [];
      });
    },
    // 文案(查询列表)
    getMediaWritingList({ state }) {
      mediawritinglist({ isPaging: 0 }).then((res) => {
        state.writinglist = res.list || [];
      });
    },
  },
  modules: {
  }
})
